import React from 'react'

/**
 * Skrzynka pocztowa starego typu zamiast dzwonka (prośby właściciela 2026-11-04): jak u listonosza, przy nowych
 * powiadomieniach chorągiewka jest podniesiona nad skrzynkę, duża i czerwona; bez nich leży opuszczona, szara, na boku
 * skrzynki. Skrzynka stoi na desce na grubym słupku. Kreska jak w ikonach heroicons (24 × 24, grubość 1,5), kolor
 * z `currentColor`.
 */
const IkonaSkrzynki = ({ podniesiona = false, className = 'h-5 w-5' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"
       className={className} aria-hidden="true" data-podniesiona={podniesiona ? 'tak' : 'nie'}>
    {/* Skrzynka z zaokrąglonym dachem, z przodu (po lewej) półokrągłe drzwiczki. */}
    <path d="M2 13.5V8.5a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4v5z" />
    <path d="M6 4.5a4 4 0 0 1 4 4v5" />
    {/* Deska pod skrzynką, słupek i ziemia. */}
    <path d="M3.5 13.5h12" />
    <path d="M8.25 13.5h2.5V21h-2.5z" />
    <path d="M5.25 21h8.5" />
    {podniesiona ? (
      // Podniesiona: ramię od osi na boku skrzynki w górę, nad nią czerwona chorągiewka.
      <g className="text-red-600">
        <path d="M15 11V1.75" />
        <path d="M15 1.75h5.75a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H15z" fill="currentColor" />
      </g>
    ) : (
      // Opuszczona: ramię wzdłuż boku skrzynki, mała chorągiewka na końcu.
      <g>
        <path d="M15 11h-4" />
        <path d="M11 11V8.25h2.5V11" />
      </g>
    )}
    <circle cx="15" cy="11" r="1" fill="currentColor" stroke="none" className={podniesiona ? 'text-red-600' : ''} />
  </svg>
)

export default IkonaSkrzynki
